/*
* @Author: MiheevAV
* @Date:   2020-07-08 16:48:29
* @Last Modified by:   MiheevAV
* @Last Modified time: 2020-07-09 10:52:23
*/

$(document).on('change', '.multiSelect', function() {
  var input = $(this).parent('td').find('input[class="multiSelect"]');
  if(input.val() == '') {
    input.val($(this).val());
  } else {
    input.val(input.val()+','+$(this).val());
  }
});


$(document).on('change', '#statusPicker', function() {
  if($('#statusBox').val() == '') {
    $('#statusBox').val($(this).val());
  } else {
    $('#statusBox').val($('#statusBox').val()+','+$(this).val());
  }
})